import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

import { responsive } from "../../utils/responsive";
import { typographyDefinition } from "../../theme/typography";
import { theme } from "../../theme/css/theme.css";

export const containerStyle = recipe({
  base: {},
  variants: {
    padding: {
      true: {
        paddingLeft: theme.spacings.m,
        paddingRight: theme.spacings.m,
        ...responsive({
          s: {
            paddingRight: theme.spacings.m,
            paddingLeft: 0,
          },
        }),
      },
    },
  },
});

export const titleStyle = style({
  fontWeight: "bold",
  ...responsive({
    s: {
      ...typographyDefinition.bodyL,
      fontWeight: "bold",
    },
  }),
});
